import { gql, useMutation } from "@apollo/client";
import { PaymentSettings, MutationUpdatePaymentSettingsArgs } from "../../__generated__/types";

const UPDATE_PAYMENT_SETTINGS_MUTATION = gql`
  mutation UpdatePaymentSettings($input: UpdatePaymentSettingsInput!) {
    updatePaymentSettings(input: $input) {
      _id
      paymentEnabled
      testMode
      testModeMessage
      lastUpdatedBy
      createdAt
      updatedAt
    }
  }
`;

export const useUpdatePaymentSettingsMutation = () => {
  const [updatePaymentSettingsMutation, { loading, error, data }] = useMutation<
    { updatePaymentSettings: PaymentSettings },
    { input: MutationUpdatePaymentSettingsArgs["input"] }
  >(UPDATE_PAYMENT_SETTINGS_MUTATION, {
    refetchQueries: ["GetPaymentSettings"],
    awaitRefetchQueries: true,
  });

  const updatePaymentSettings = async (input: MutationUpdatePaymentSettingsArgs["input"]): Promise<PaymentSettings> => {
    try {
      const result = await updatePaymentSettingsMutation({
        variables: { input },
      });
      return result?.data?.updatePaymentSettings!;
    } catch (err) {
      console.error("Error updating payment settings:", err);
      throw err;
    }
  };

  return { updatePaymentSettings, loading, error, data };
};

